/*
 * fn: escapeHtml
 *
 * Escapes HTML-reserved characters to ASCII
 *
 */
export const escapeHtml = (input: string = '') =>
  input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
